export const snackBar = (message, type = 'success') => {
  const snackBar = document.createElement('d4l-snack-bar');
  const snackBarIconContainer = document.createElement('div');
  const snackBarContent = document.createElement('span');

  let snackBarIcon;
  if (type === 'success') {
    snackBarIcon = document.createElement('d4l-icon-check');
  } else {
    snackBarIcon = document.createElement('d4l-icon-info');
  }

  snackBarIconContainer.slot = 'snack-bar-icon';
  snackBarIconContainer.style.marginRight = '0.5rem';
  snackBarIcon.classes = 'icon--small';
  snackBarIconContainer.appendChild(snackBarIcon);

  snackBarContent.slot = 'snack-bar-content';
  snackBarContent.innerHTML = message;

  snackBar.type = type;
  snackBar.style.margin = '1.5rem 0';
  snackBar.style.display = 'block';
  snackBar.appendChild(snackBarContent);
  snackBar.appendChild(snackBarIconContainer);

  return snackBar;
}
